import { useState } from 'react';
import './CTA.css';

export default function CTA() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setSubmitted(true);
    }
  };

  return (
    <section className="cta" id="contact">
      {/* Decorative elements */}
      <div className="cta__bg">
        <div className="cta__blob cta__blob--1" />
        <div className="cta__blob cta__blob--2" />
        <div className="cta__blob cta__blob--3" />
      </div>

      <div className="container cta__inner">
        <div className="cta__mascot">🐰</div>

        <div className="cta__content">
          <div className="cta__badge">
            <span className="cta__badge-dot" />
            Bêta gratuite ouverte
          </div>

          <h2 className="cta__title">
            Prêt à transformer les routines<br />
            de votre famille ?
          </h2>

          <p className="cta__subtitle">
            Rejoignez les premières familles qui testent Evolify. Gratuit pendant toute la bêta. Partagez vos retours et faites partie de l'aventure.
          </p>

          {!submitted ? (
            <form className="cta__form" onSubmit={handleSubmit}>
              <div className="cta__form-input-wrap">
                <span className="cta__form-icon">📧</span>
                <input
                  type="email"
                  placeholder="Votre adresse e-mail"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  className="cta__form-input"
                  required
                />
              </div>
              <button type="submit" className="btn-primary cta__form-btn">
                Rejoindre la bêta gratuite →
              </button>
            </form>
          ) : (
            <div className="cta__success">
              <span className="cta__success-icon">🎉</span>
              <div>
                <p className="cta__success-title">Bienvenue dans l'aventure Evolify !</p>
                <p className="cta__success-sub">Nous vous contacterons très bientôt. Merci de votre confiance.</p>
              </div>
            </div>
          )}

          <div className="cta__guarantees">
            <span>✓ Gratuit pendant la bêta</span>
            <span>✓ Sans engagement</span>
            <span>✓ Données protégées</span>
          </div>
        </div>

        {/* Right side: key facts */}
        <div className="cta__facts">
          <div className="cta__fact">
            <div className="cta__fact-icon">⏱️</div>
            <div>
              <p className="cta__fact-number">2 min</p>
              <p className="cta__fact-label">par jour maximum</p>
            </div>
          </div>
          <div className="cta__fact">
            <div className="cta__fact-icon">📵</div>
            <div>
              <p className="cta__fact-number">0</p>
              <p className="cta__fact-label">dépendance numérique</p>
            </div>
          </div>
          <div className="cta__fact">
            <div className="cta__fact-icon">🤝</div>
            <div>
              <p className="cta__fact-number">100%</p>
              <p className="cta__fact-label">co-construit</p>
            </div>
          </div>
          <div className="cta__fact">
            <div className="cta__fact-icon">🧠</div>
            <div>
              <p className="cta__fact-number">TAD</p>
              <p className="cta__fact-label">base scientifique</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
